const baseURL = process.env.REACT_APP_API_URL;

// Media (user uploads) URLs come back from the API as either an absolute URL
// (S3 storage) or a root-relative path like ``/media/...`` (local
// FileSystemStorage). A relative path would otherwise resolve against the SPA
// origin and 404, so prefix it with the API origin. Absolute URLs are returned
// untouched.
const resolveMediaUrl = (url) => {
    if (!url || /^https?:\/\//i.test(url)) {
        return url;
    }

    // Media is served at the API HOST ROOT (e.g. https://api.kovaapp.com/media/),
    // NOT under the /api path. REACT_APP_API_URL includes the /api suffix, so
    // prefix with its ORIGIN only — otherwise we'd build /api/media/... (404).
    const apiBase = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
    let origin = apiBase;
    try {
        origin = new URL(apiBase).origin;
    } catch (e) {
        origin = apiBase.replace(/\/api\/?$/, '');
    }

    return `${origin}${url.startsWith('/') ? '' : '/'}${url}`;
};

const endPoints = {
    user: {
        base: '/user/',
        login: '/auth/jwt/create/',
    },
    cleaner: {
        base: '/cleaner/',
    },
    verification: {
        // re-verification flow: read current status + submit a new attempt
        status: '/users/verification/status/',
        submit: '/users/verification/submit/',
        // partial resubmission: re-upload a single rejected document {type, file}
        documents: '/users/verification/documents/',
        // phone OTP
        sendOtp: '/users/phone/send-otp/',
        verifyOtp: '/users/phone/verify/',
    },
    order: {
        base: '/order/',
        byCurrentUser: '/order/current-user-orders/',
    },
    offer: {
        base: '/offer/',
        byCurrentUser: '/offer/current-user-offers/',
    },
    servicePackages: {
        base: '/service-package/'
    },
    cleaningRequest: {
        base: '/cleaning-request/',
        byCurrentUser: '/cleaning-request/current-user-requests/',
        // Reschedule an EXPIRED request back to CREATED with a new datetime
        reschedule: (id) => `/cleaning-request/${id}/reschedule/`,
        // Deactivate (CANCEL) a request
        deactivate: (id) => `/cleaning-request/${id}/deactivate/`,
    },
    additionalServices: {
        base: '/service/'
    },
    application: {
        base: '/cleaner-application/',
        byCurrentUser: '/cleaner-application/current-user-applications/',
    },
    feedback: {
        toClient: '/to-client-feedback/',
        toCleaner: '/to-cleaner-feedback/',
    },
    serviceTypes: {
        base: '/service-type'
    },
    qrCode: {
        generate: '/generate-qr/',
    },
    support: {
        tickets: '/support/tickets/',
    },
    passwordRecovery: {
        sendLink: "user/send-password-recovery/",
        setNewPassword: "user/password-recovery/"
    },
    cities: {
        // public read of active / serviceable cities (admin manages the catalog)
        public: '/cities/',
    },
    promotions: {
        // public read of live promotions ("Акції"); admin manages the catalog
        base: '/promotions/',
        apply: '/promotions/apply/',
    },
};

export {
    baseURL,
    endPoints,
    resolveMediaUrl,
}
